<template lang="pug">
include situation-default.pug
</template>

<style lang="scss" scoped>
@import 'situation-default';
</style>

<script>
import NavigationButtons from '@/components/shared/navigationButtons'
import { ApplicationTypes, PassportSituations, DrivingLicenseSituation, MinimumAges } from '@/models'
import services from '@/services'
import { createNamespacedHelpers } from 'vuex'
import situations from '@/models/situations'
import ageUtils from '@/utils/ageUtils'

import { getterTypes, mutationTypes } from '@/store/application'
const { mapState: mapGlobalState } = createNamespacedHelpers('globals')
const applictionStore = createNamespacedHelpers('application')
const oidcStore = createNamespacedHelpers('oidc')

export default {
  name: 'SituationDefault',
  components: {
    navigationButtons: NavigationButtons
  },
  computed: {
    ...applictionStore.mapState({
      applicationType: (state) => state.applicationType,
      fstyrActivitiesEnabled: (state) => state.fstyrActivitiesEnabled
    }),
    ...applictionStore.mapGetters({
      personApplication: getterTypes.CURRENT
    }),
    ...oidcStore.mapGetters({
      user: 'oidcUser'
    }),
    situations: function () {
      if (!this.personApplication) {
        return []
      }
      const cprNumber = this.user.cpr_number
      const all = situations.get(this.personApplication.caseType).filter((i) => this.fstyrActivitiesEnabled || !i.fstyr)
      if (ageUtils.hasReachedAge(cprNumber, MinimumAges.Adult)) {
        return all
      }
      return all.filter((i) => !i.minimumAge || ageUtils.hasReachedAge(cprNumber, i.minimumAge))
    },
    ...mapGlobalState({
      texts: (state) => state.texts.situation
    }),
    previousStepAvailable: function () {
      return services.application.previousStepAvailable()
    },
    nextStepAllowed: function () {
      return this.personApplication && !!this.personApplication.situation.id
    }
  },
  methods: {
    ...applictionStore.mapMutations({
      setSituationId: mutationTypes.SET_SITUATION_ID,
      setNewDocument: mutationTypes.SET_NEW_DOCUMENT,
      setPreviousDocumentLost: mutationTypes.SET_PREVIOUS_DOCUMENT_LOST,
      setPreviouslyHadDanishPassport: mutationTypes.SET_PREVIOUSLY_HAD_DANISH_PASSPORT,
      setInPossessionOfOldPassport: mutationTypes.SET_IN_POSESSION_OF_OLD_PASSPORT
    }),
    onPreviousStepClicked: function () {
      services.application.previousStep()
    },
    onNextStepClicked: function () {
      const situationId = this.personApplication.situation.id
      let lostOrStolen

      switch (this.applicationType) {
        case ApplicationTypes.Passport:
          lostOrStolen = [PassportSituations.Stolen, PassportSituations.Lost].includes(situationId)

          this.setPreviouslyHadDanishPassport(situationId !== PassportSituations.New)

          if (lostOrStolen) {
            this.setInPossessionOfOldPassport(false)
          }
          break
        case ApplicationTypes.DrivingLicense:
          lostOrStolen = DrivingLicenseSituation.Lost === situationId
          break
      }

      this.setPreviousDocumentLost(lostOrStolen)

      if (!lostOrStolen) {
        this.setNewDocument(true)
        services.application.nextStep()
      }
    }
  }
}
</script>
